import { render, staticRenderFns } from "./cdhkzyjsxy.vue?vue&type=template&id=0a2b68ba&scoped=true&"
import script from "./cdhkzyjsxy.vue?vue&type=script&lang=js&"
export * from "./cdhkzyjsxy.vue?vue&type=script&lang=js&"
import style0 from "./cdhkzyjsxy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cdhkzyjsxy.vue?vue&type=style&index=1&id=0a2b68ba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b68ba",
  null
  
)

export default component.exports